
const StationHeaderBadge: React.FC<{ label: string; value: string }> = ({ label, value }) => (
  <div className="flex flex-col items-center gap-1 w-16">
    <span className="text-neutral-60 typo-small">{label}</span>
    <div className="flex items-center justify-center">
      <span className="text-neutral typo-body">{value}</span>
    </div>
  </div>
);

export default StationHeaderBadge;